import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Tabs, Tab, Divider, Card, CardContent } from '@mui/material';
import { useParams } from 'react-router-dom';
import { Page, Header } from 'components';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import AddBoxIcon from '@mui/icons-material/AddBox';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import IosShareIcon from '@mui/icons-material/IosShare';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { ExportFailuresVoice, ToggleOptionsFailuresTrackerDialog, ToggleVoiceEditFailureDialog } from '../actions/VoiceActions';
import { ExportFailuresPacket } from '../actions/PacketActions';
import Voice from './components/Voice/Voice';
import Packet from './components/Packet/Packet';
import FailuresTrackerOptionsDialog from './components/FailuresTrackerOptionsDialog';

const tabs = [
	{ value: 'voice', label: 'voice' },
	{ value: 'packet', label: 'packet' },
];

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const Failures = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { id } = useParams();

	const [tab, setTab] = useState('voice');

	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	const optionsFailuresTrackerDialogVisibility = useSelector((state) => state.failuresReducer.optionsFailuresTrackerDialogVisibility);

	const getData = useCallback(() => {
		if (id !== '0') {
			dispatch(ToggleVoiceEditFailureDialog(true, id));
		}
	}, []);

	useEffect(() => {
		getData();
	}, []);

	const handleTabsChange = (event, value) => {
		setTab(value);
	};

	const _onOptionsClick = () => {
		dispatch(ToggleOptionsFailuresTrackerDialog(true));
	};

	const _optionsFailuresTrackerDialogClose = () => {
		dispatch(ToggleOptionsFailuresTrackerDialog(false));
	};

	const actions = [
		{ icon: <IosShareIcon />, name: 'Export Incidents', id: 'exportIncidents' },
	];

	if (role === 'Administrator' || role === 'Manager') {
		actions.push({ icon: <ManageAccountsIcon />, name: 'Options', id: 'options' });
	}

	const _handleSpeedDialClick = (action) => {
		if (action.id === 'exportIncidents') {
			if (tab === 'voice') {
				dispatch(ExportFailuresVoice(userId, role));
			} else {
				dispatch(ExportFailuresPacket(userId, role));
			}
		} else if (action.id === 'options') {
			_onOptionsClick();
		}
	};

	return (
		<Page className={classes.root} title="Failures">
			<Header module="Modules" view="Failures" />
			<SpeedDial
				ariaLabel="SpeedDial"
				sx={{ position: 'absolute', bottom: 16, right: 16 }}
				icon={<SpeedDialIcon />}
			>
				{actions.map((action) => (
					<SpeedDialAction
						key={action.name}
						icon={action.icon}
						tooltipTitle={action.name}
						onClick={() => { _handleSpeedDialClick(action); }}
					/>
				))}
			</SpeedDial>
			<Card className={classes.container}>
				<CardContent>
					<Tabs
						className={classes.tabs}
						onChange={handleTabsChange}
						scrollButtons="auto"
						value={tab}
						variant="scrollable"
					>
						{tabs.map((t) => (
							<Tab key={t.value} label={t.label} value={t.value} />
						))}
					</Tabs>
					<Divider className={classes.divider} />
					<div className={classes.content}>
						{tab === 'voice' && <Voice />}
						{tab === 'packet' && <Packet />}
						{/* {tab === 'packet' && <h2>Under construction</h2>} */}
					</div>
				</CardContent>
			</Card>
			{optionsFailuresTrackerDialogVisibility && (
				<FailuresTrackerOptionsDialog
					onClose={_optionsFailuresTrackerDialogClose}
					open={optionsFailuresTrackerDialogVisibility}
					tab={tab}
				/>
			)}
		</Page>
	);
};

export default Failures;
